import { ConnectionChangeRequestStatusEnum } from '@bo-client/shared/models/connectionChange.dto';
import { StatusDefinition } from '../status.model';

/** Anschlussänderung (`ConnectionChangeRequest.state`). */
export const CONNECTION_CHANGE_REQUEST_STATUS_DEFINITIONS: readonly StatusDefinition[] = [
  {
    value: ConnectionChangeRequestStatusEnum.Incomplete,
    defaultLabel: 'Unvollständig',
    defaultColor: '#f0b429'
  },
  { value: ConnectionChangeRequestStatusEnum.Requested, defaultLabel: 'Angefragt', defaultColor: '#71dde3' },
  { value: ConnectionChangeRequestStatusEnum.Error, defaultLabel: 'Fehler', defaultColor: '#fd7e14' },
  { value: ConnectionChangeRequestStatusEnum.Expired, defaultLabel: 'Abgelaufen' },
  {
    value: ConnectionChangeRequestStatusEnum.FeedbackNeeded,
    defaultLabel: 'Rückfrage',
    defaultColor: '#f0b429'
  },
  {
    value: ConnectionChangeRequestStatusEnum.OfferSent,
    defaultLabel: 'Angebot per E-Mail versandt',
    defaultColor: '#C3E88D'
  },
  { value: ConnectionChangeRequestStatusEnum.Ordered, defaultLabel: 'Beauftragt', defaultColor: '#e99aa6' }
];
